import React from 'react';
import ShopCheck from '../../components/ShopElements/ShopCheck';
import PageHeader from '../Shared/PageHeader';

const CheckOut = () => {
    return (
        <div>
            <PageHeader title="Checkout" />
            <ShopCheck />
        </div>
    );
};

export default CheckOut;